export default __webpack_public_path__ + "static/omnibar-concept-dark-f529f656d2953fe8e465a7ad9d319f56f83ec962f41f9ae801283e6720ba2d91.mp4";